import { action } from 'satcheljs';
import type MeetingMessageAddToCalendarStatus from '../store/schema/MeetingMessageAddToCalendarStatus';

export interface MeetingMessageAddToCalendarStatusChangedActionMessage {
    status: MeetingMessageAddToCalendarStatus;
    sxsId: string | null;
}
const defaultExport: (
    status: MeetingMessageAddToCalendarStatus,
    sxsId: string | null
) => MeetingMessageAddToCalendarStatusChangedActionMessage = action(
    'meetingMessageAddToCalendarStatusChanged',
    (
        status: MeetingMessageAddToCalendarStatus,
        sxsId: string | null
    ): MeetingMessageAddToCalendarStatusChangedActionMessage => ({
        status,
        sxsId,
    })
);
export default defaultExport;
